module.exports = __webpack_public_path__ + "img/5-4.d707e9f1.png";